<template>
    <div class="still">
        <div class="logo"><img src="../assets/logo.png" alt="logo"></div>
        <div class="still-image"><img v-bind:src="urlStill"></div>
        <div class="still-title">{{ titleStill }}</div>
        <div class="button-home">
            <img src="../assets/buttons/back.png" alt="home" @click="goBack">
        </div>
    </div>
</template>

<script>
import config from '../config/app.json';
import axios from 'axios';
import router from '../router';
export default {
    name: 'Still',
    props: ["fileId"],
    data() {
        return {
            urlStill: '',
            titleStill: '',
            itemId: null
        }
    },
    methods: {
        goBack: () => {
            router.push('/reuniekaart');
        }
    },
    created() {
        axios.get(config.api + 'files/' + this.fileId +'?key=' + config.api_key)
        .then((stillRes) => {
            // console.log('stillresult: ' + JSON.stringify(stillRes.data.file_urls.fullsize));
            this.urlStill = stillRes.data.file_urls.fullsize;
            this.itemId = stillRes.data.item.id;
            axios.get(config.api + 'items/' + this.itemId +'?key=' + config.api_key)
            .then((itemRes) => {
                itemRes.data.element_texts.forEach(element_text => {
                    if(element_text.element.name === 'Title') {
                        this.titleStill = element_text.text;
                    }
                });
            })
            .catch();
        })
        .catch();
    }
}
</script>

<style scoped>
.still {
    background-color: #cccc99;
    width: 1920px;
    height: 1080px;
    overflow: hidden;
}
.still-image {
    position: absolute;
    display: flex;
    top: 180px;
    left: 320px;
    width: 1280px;
    height: 720px;
    align-items: center;
    background-color: #00000011;
}
.still-image img {
    object-fit: contain;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
}
.still-title {
    position: absolute;
    bottom: 120px;
    left: 320px;
    width: 1280px;
    color: #c1292f;
    text-align: left;
}
.logo {
    position: absolute;
    top: 80px;
    left: 1645px;
    width: 120px;
    height: auto;
}
.logo img {
    width: 100%;
    height: auto;
}
.button-home {
    position: absolute;
    top: 117px;
    left: 60px;
    width: 45px;
}
.button-home img {
    width: 100%;
    height: auto;
}

</style>